"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const youtube_player_1 = __importDefault(require("youtube-player"));
let player;
exports.default = {
    mounted() {
        let parent = this;
        let container = this.el;
        let videoElement = document.getElementById("yt-player-temp");
        let volume_button = container.querySelector(".volume-button");
        let set_audio_button = function (volume) {
            var cur_elem = Array.from(volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList).find(t => t.includes("bi-"));
            volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList.remove(cur_elem);
            if (volume == 0) {
                volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList.add("bi-volume-mute-fill");
            }
            else if (volume > 75) {
                volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList.add("bi-volume-up-fill");
            }
            else if (volume > 35) {
                volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList.add("bi-volume-down-fill");
            }
            else {
                volume_button === null || volume_button === void 0 ? void 0 : volume_button.classList.add("bi-volume-off-fill");
            }
        };
        let volume = window.localStorage.getItem("audio-volume");
        let volumemuted = Number.parseInt(window.localStorage.getItem("audio-muted")) == 1;
        volume_button === null || volume_button === void 0 ? void 0 : volume_button.addEventListener("click", () => {
            player.getVolume().then(vol => {
                if (vol == 0) {
                    if (volume == 0) {
                        volume = 20;
                        setAudio(volume);
                    }
                    else {
                        setAudio(volume);
                    }
                    window.localStorage.setItem("audio-muted", "0");
                }
                else {
                    setAudio(0);
                    window.localStorage.setItem("audio-muted", "1");
                }
            });
        });
        let audio_bar = container.querySelector(".audio-bar");
        let clientX = 0;
        let audio_set_active = false;
        let audio_bar_fill_func = function (volume) {
            let fill = audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.querySelector(".audio-bar-fill");
            fill.style.width = volume + "%";
        };
        let setAudio = function (volume, save = false) {
            let mx = audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.clientWidth;
            if (save) {
                audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.setAttribute("data-volume-px", (mx * (volume / 100)).toString());
                window.localStorage.setItem("audio-volume", volume.toString());
            }
            audio_bar_fill_func(volume);
            set_audio_button(volume);
            player.setVolume(volume);
        };
        let audio_bar_drag = function (event, save = false) {
            event.preventDefault();
            let volumePx = Number.parseInt(audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.getAttribute("data-volume-px"));
            let mx = audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.clientWidth;
            if (event.type.includes("touch")) {
                let me = event;
                volumePx += me.changedTouches[0].pageX - clientX;
            }
            else
                volumePx += event.pageX - clientX;
            if (volumePx < 0)
                volumePx = 0;
            if (volumePx > mx)
                volumePx = mx;
            volume = (volumePx / mx) * 100;
            setAudio(volume, save);
        };
        audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.addEventListener("touchstart", (event) => {
            event.preventDefault();
            audio_set_active = true;
            clientX = event.changedTouches[0].pageX;
            document.addEventListener("touchmove", audio_bar_drag);
        });
        document.addEventListener("touchend", (event) => {
            if (audio_set_active) {
                audio_set_active = false;
                event.preventDefault();
                audio_bar_drag(event, true);
                document.removeEventListener("touchmove", audio_bar_drag);
            }
        });
        audio_bar === null || audio_bar === void 0 ? void 0 : audio_bar.addEventListener("mousedown", (event) => {
            clientX = event.pageX;
            if (event.buttons == 1) {
                audio_set_active = true;
                document.addEventListener("mousemove", audio_bar_drag);
            }
        });
        document.addEventListener("mouseup", (event) => {
            if (audio_set_active) {
                audio_set_active = false;
                audio_bar_drag(event, true);
                document.removeEventListener("mousemove", audio_bar_drag);
            }
        });
        let fullscreen = container.querySelector(".fullscreen");
        document.onfullscreenchange = () => {
            console.log(!!document.fullscreenElement);
            if (!!document.fullscreenElement) {
                fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.classList.remove("bi-fullscreen");
                fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.classList.add("bi-fullscreen-exit");
                setFullscreenData(container, true);
            }
            else {
                fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.classList.remove("bi-fullscreen-exit");
                fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.classList.add("bi-fullscreen");
                setFullscreenData(container, false);
            }
        };
        fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.addEventListener("click", () => {
            if (!!document.fullscreenElement) {
                document.exitFullscreen();
            }
            else {
                container.requestFullscreen();
            }
        });
        this.handleEvent("load_yt_video", ({ id }) => {
            if (player) {
                player.loadVideoById(id);
            }
            else {
                player = youtube_player_1.default(videoElement, {
                    videoId: id,
                    playerVars: {
                        disablekb: 1,
                        controls: 0,
                        iv_load_policy: 3,
                        origin: window.location.origin,
                        cc_lang_pref: "en",
                        cc_load_policy: 1
                    }
                });
                player.playVideo();
                checkPlayer();
                player.on("ready", () => {
                    player.playVideo();
                });
                player.on("error", (error) => {
                    console.error(error);
                });
                if (!volumemuted)
                    if (volume != null) {
                        volume = Number.parseInt(volume);
                        setAudio(volume, true);
                    }
                    else {
                        volume = 50;
                        setAudio(volume, true);
                    }
                else
                    setAudio(0);
                window.ytPlayer = player;
            }
        });
    },
    destroyed() {
        if (player) {
            player.destroy();
        }
    }
};
function checkPlayer() {
    setTimeout(() => {
        player.getPlayerState().then(status => {
            if (status == -1) {
                player.playVideo();
                checkPlayer();
            }
        });
    }, 2000);
}
function setFullscreenData(container, state) {
    container.setAttribute('data-fullscreen', !!state);
}
